import React from "react";

import { Input } from "~/components/input";
import { useScope } from "~/tools/impulse";

import type { WidgetMetricLabel } from "./form-state";

export interface WidgetMetricLabelFieldProps {
	name: string;
	metricLabel: WidgetMetricLabel;
}

export const WidgetMetricLabelField: React.FC<WidgetMetricLabelFieldProps> = ({ name, metricLabel }) => {
	const scope = useScope();

	return (
		<Input
			name={name}
			onChange={(event) => metricLabel.setInput(event.target.value)}
			value={metricLabel.getInput(scope)}
		/>
	);
};
